export const MULTIPLE_COVER_CONTENT = 'MULTIPLE_COVER_CONTENT';
export const multipleCoverContentSetter = q => ({
  type: MULTIPLE_COVER_CONTENT,
  payload: q
});
